import * as tslib_1 from "tslib";
import { EventEmitter, Injector, ElementRef, OnInit } from '@angular/core';
import { ComponentBase } from './component-base';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ValidationSummaryComponent } from '../../components/validation-summary/validation-summary.component';
import { NotifierService } from '../../services/notifier.service';
import { Dialog } from 'primeng/dialog';
import { CommonService } from '../../services/common.service';
import { FileUpload } from 'primeng/primeng';
import { CONFIG_CALENDAR_VIETNAMESE } from '../../../config/calendar.config';
import { VsMySettingService } from '../../../services/ccmysetting.service';
import { VsMySetting } from '../../../models/ccmysetting';
export class SecondPageEditBase extends ComponentBase {
    constructor(_baseService, _injector) {
        super();
        this._baseService = _baseService;
        this._injector = _injector;
        this.vi = CONFIG_CALENDAR_VIETNAMESE;
        this.isShow = false;
        this.submitting = false;
        this.openPopupDelete = false;
        this.itemDetail = {};
        this.formSchema = [];
        this.uploadedFiles = [];
        this.popupHeader = '';
        this.formGroup = new FormGroup({});
        this.limitAll = 10000;
        this.arrTrangThai = [
            { label: 'Sử dụng', value: 1 },
            { label: 'Không Sử dụng', value: 2 }
        ];
        this.closePopup = new EventEmitter();
        this.mySetting = new VsMySetting();
        this.splitYearMonth = (s) => {
            if (typeof s !== 'string')
                return null;
            const parts = s.split('-');
            if (parts.length !== 2)
                return null;
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10);
            if (isNaN(year) || isNaN(month) || month < 1 || month > 12)
                return null;
            return { year, month };
        };
        this._mySettingService = this._injector.get(VsMySettingService);
        this._notifierService = this._injector.get(NotifierService);
        this.popupId = this._injector.get(CommonService).guid();
        this.mySetting = this._mySettingService.getCurrentSetting();
        // this._masterDataService.getConfigByCode('SizeOfFile')
        //     .then(response => {
        //         if (response) {
        //             this.limitSize = Number(response) * 1000 * 1000;
        //         }
        //     });
    }
    ngOnInit() {
        // this._masterDataService.getConfigByCode('SizeOfFile')
        //     .then(response => {
        //         if (response) {
        //             this.limitSize = Number(response) * 1000 * 1000;
        //         }
        //     });
    }
    save() {
        this.submitting = true;
        if (this.formGroup.invalid) {
            this.validationSummary.showValidationSummary();
            this.showValidateMessage();
            this.submitting = false;
            this.scrollToTop();
            return;
        }
        this.onBeforeSave();
        if (this.itemDetail['id']) {
            this.onUpdate();
        }
        else {
            this.onInsert();
        }
    }
    showValidateMessage() {
    }
    onBeforeSave() {
    }
    onAfterSave() {
    }
    showPopup(data = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.isShow = true;
            this.openPopupDelete = false;
            yield this.onShowPopup(data);
            setTimeout(() => {
                const viewRef = document.getElementById(this.popupId);
                if (viewRef != null) {
                    const input = viewRef.querySelector('input');
                    if (input) {
                        input.focus();
                    }
                    else {
                        const texateara = viewRef.querySelector('textarea');
                        if (texateara) {
                            texateara.focus();
                        }
                    }
                }
                if (this.dialog) {
                    this.dialog.center();
                }
            }, 500);
        });
    }
    onShowPopup(data) {
        this.onReset();
        this.onBeforeShowPopUp();
        if (data > 0) {
            this._baseService.getDetail(data)
                .then((response) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                this.itemDetail = response.data;
                this.onAfterShowPopUp();
            }), error => {
                this._notifierService.showHttpUnknowError();
            });
        }
    }
    onReset() {
        this.itemDetail = {};
    }
    onAfterShowPopUp() {
    }
    onBeforeShowPopUp() {
    }
    closePopupMethod(data) {
        this.isShow = false;
        this.closePopup.next(data);
    }
    getMaxWidthDialog() {
        return (window.innerHeight - 200).toString() + 'px';
    }
    onInsert() {
        this._baseService.post(this.itemDetail)
            .then(response => {
            this.closePopupMethod(true);
            this._notifierService.showInsertDataSuccess();
            this.onAfterSave();
            this.submitting = false;
        }, error => {
            this._notifierService.showInsertDataFailed();
            this.submitting = false;
        });
    }
    onUpdate() {
        this._baseService.put(this.itemDetail['id'].toString(), this.itemDetail)
            .then(response => {
            this.closePopupMethod(true);
            this._notifierService.showUpdateDataSuccess();
            this.onAfterSave();
            this.submitting = false;
        }, error => {
            this._notifierService.showUpdateDataFailed();
            this.submitting = false;
        });
    }
    cancel() {
        this.closePopupMethod(null);
    }
    buildFormGroup(formGroup, formSchema) {
        const formGroupD = formGroup || this.formGroup;
        const formSchemaD = formSchema || this.formSchema;
        for (let i = 0; i < formSchemaD.length; i++) {
            const schemaItem = formSchemaD[i];
            const formControl = new FormControl('');
            if (schemaItem.control && schemaItem.control.defaultValue !== undefined) {
                this.itemDetail[schemaItem.field] = schemaItem.control.defaultValue;
                if (!schemaItem.visible && schemaItem.control.defaultValue) {
                    formControl.setValue(schemaItem.control.defaultValue);
                }
            }
            if (schemaItem.validators && schemaItem.validators.required) {
                formControl.setValidators(Validators.required);
            }
            formGroupD.addControl(schemaItem.field, formControl);
        }
    }
    resetForm() {
        if (this.validationSummary) {
            this.validationSummary.resetErrorMessages();
        }
        if (this.pUpload) {
            this.pUpload.clear();
        }
        this.formGroup.reset();
        this.itemDetail = {};
        this.uploadedFiles = [];
        this.submitting = false;
    }
    delete(id) {
        this._notifierService.showDeleteConfirm().then(rs => {
            this._baseService.delete(id)
                .then(response => {
                this.closePopupMethod({});
                this._notifierService.showDeleteDataSuccess();
            }, error => {
                this._notifierService.showDeleteDataError();
            });
        });
    }
    scrollToTop() {
        if (this.formElement) {
            setTimeout(() => {
                this.formElement.nativeElement.scrollIntoView();
            }, 500);
        }
    }
    isValid(submitting = true) {
        if (this.formGroup.invalid) {
            this.validationSummary.showValidationSummary();
            this.submitting = false;
            return;
        }
        this.validationSummary.resetErrorMessages();
        return this.formGroup.valid;
    }
    togglePopupDelete() {
        this.openPopupDelete = !this.openPopupDelete;
    }
    resetDialogPosition() {
        window.setTimeout(() => {
            this.dialog.center();
        });
    }
    getMaxDialogHeight() {
        return (window.innerHeight - 200).toString() + 'px';
    }
    handleTabChange(event) {
        this.resetDialogPosition();
    }
    convertDataToOptions(options, data, fieldName) {
        if (data.length > 0) {
            data.map(item => options.push({ label: item[fieldName], value: item.id }));
        }
    }
    mapJsonToDetailAddress(data) {
        return {
            place_id: data.place_id,
            licence: data.licence,
            osm_type: data.osm_type,
            osm_id: data.osm_id,
            lat: data.lat,
            lon: data.lon,
            class: data.class,
            type: data.type,
            place_rank: data.place_rank,
            importance: data.importance,
            addresstype: data.addresstype,
            name: data.name,
            display_name: data.display_name,
            address: {
                road: data.address.road,
                quarter: data.address.quarter,
                suburb: data.address.suburb,
                city: data.address.city,
                ISO3166_2_lvl4: data.address.ISO3166_2_lvl4,
                postcode: data.address.postcode,
                country: data.address.country,
                country_code: data.address.country_code
            },
            boundingbox: data.boundingbox
        };
    }
    buildTree(data, parentId = null) {
        const result = [];
        // Nếu parentId là null, ta sẽ tìm tất cả các mục có idParent là 0 (thằng cha to nhất)
        //const filteredData = parentId === null ? data.filter(item => item.idParent === 0) : data.filter(item => item.idParent === parentId);
        data
            .filter(item => item.idParent === parentId)
            .forEach(item => {
            const children = this.buildTree(data, item.id);
            const newNode = {
                idParent: item.idParent,
                id: item.id,
                name: item.name,
                checked: false,
                expanded: false,
                children: children.length ? children : undefined
            };
            result.push(newNode);
        });
        return result;
    }
    flattenTree(nodes, level = 0) {
        let result = [];
        nodes.forEach(node => {
            result.push({
                label: `${' _  '.repeat(level)} ${node.name}`,
                value: node.id
            });
            if (node.children) {
                result = result.concat(this.flattenTree(node.children, level + 1));
            }
        });
        return result;
    }
    generateTimeList(startH, startM, endH, endM, step) {
        const times = [];
        let hour = startH;
        let minute = startM;
        while (hour < endH || (hour === endH && minute <= endM)) {
            if (hour === 24 && minute > 0)
                break; // tránh 24:30
            const hh = hour.toString().padStart(2, '0');
            const mm = minute.toString().padStart(2, '0');
            times.push({ label: `${hh}:${mm}`, value: `${hh}:${mm}` });
            minute += step;
            if (minute >= 60) {
                minute = 0;
                hour++;
            }
        }
        return times;
    }
}
